import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { getDatepickerLocale } from '@/helpers/LocaleHelper';

interface Props {
    name: any;
    job: any;
    isDefault: any;
    birthday: any;
    isCompany: any;
    hasNameError?: any;
    useDefaultAddress?: boolean;
    isNewClient?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactPersonBasicInfo',
  props: {
    name: null,
    job: null,
    isDefault: null,
    birthday: null,
    isCompany: null,
    hasNameError: null,
    useDefaultAddress: { type: Boolean },
    isNewClient: { type: Boolean }
  },
  emits: ["update:name", "update:job", "update:birthday", "default-change", "update:useDefaultAddress"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:name', value: string): void;
    (e: 'update:job', value: string): void;
    (e: 'update:birthday', value: any): void;
    (e: 'default-change', value: boolean): void;
    (e: 'update:useDefaultAddress', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





function onDefaultAddressChange(checked: boolean) {
    emit('update:useDefaultAddress', checked);
}

const locale = computed(() => getDatepickerLocale());

return { __sfc: true,emit, onDefaultAddressChange, locale }
}

})